import { QuickTable, QuickTableFilterTabs } from "../../components";
import { CreatePayment } from "./CreatePayment";
import { paymentDisplayFormatter } from "./paymentDisplayFormatter";
import { IPaymentViewProps } from "./Payments";

export const View = (props: IPaymentViewProps) => {
  return (
    <>
      <QuickTable
        id="paymentsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={paymentDisplayFormatter}
        onExport={props.onExport}
        onCreateNew={props.onCreateNew}
      />

      <CreatePayment
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
